import { Accordion, Typography } from '@sunwebgroup/ui-components';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { createDataLayerEvent } from '@/scopes/products/pages/components/PracticalInformation/helpers/CreateDataLayerEvent';

export interface CountryInfoProps {
  title: string;
  details: string;
}

export function CountryInfo({ title, details }: CountryInfoProps) {
  const { sendEvent } = useAnalytics();

  const handleChange = (isOpen: boolean) => {
    if (isOpen) {
      sendEvent(createDataLayerEvent({ element: 'Country info', isOpen: true }));
    } else {
      sendEvent(createDataLayerEvent({ element: 'Country info', isOpen: false }));
    }
  };

  return (
    <Accordion.Item title={title} icon="IconPinMap" onOpenChange={handleChange}>
      <Typography dangerouslySetInnerHTML={{ __html: details }} />
    </Accordion.Item>
  );
}
